import { fetchClient } from '@/shared/apis';
import type { components } from '@/shared/apis/fastfive';
import type { BlogArticle, DescriptionKey, ResolvedConfig, ResultConfig, TitleKey } from './_types';

type BlogCardDetail = components['schemas']['BlogCardDetail'];

// ── 제목 ─────────────────────────────────────────────────────
export const TITLES: Record<TitleKey, string> = {
  counsel: '상담 신청이<br /> 접수되었습니다',
};

// ── 설명 ─────────────────────────────────────────────────────
export const DESCRIPTIONS: Record<DescriptionKey, string> = {
  reply: '담당 매니저가 빠르게<br /> 연락드리겠습니다.',
};

// ── 완료 화면 조합 ────────────────────────────────────────────
export const RESULT_CONFIGS: Record<string, ResultConfig> = {
  default: {
    title: 'counsel',
    description: 'reply',
  },
};

// ── 헬퍼 ─────────────────────────────────────────────────────
export function toBlogArticle(blog: BlogCardDetail): BlogArticle | null {
  if (!blog.title) return null;
  return {
    image: blog.thumbnailUrl,
    category: blog.category?.name,
    color: blog.category?.color,
    title: blog.title,
    href: blog.slug ? `/blog/${blog.slug}` : `/blog/${blog.id}`,
    time: blog.readingTimeMinutes,
    date: blog.displayPublishAt?.slice(0, 10).replaceAll('-', '.'),
    hashtag: blog.hashtag,
  };
}

/** configKey → 실제 렌더링 데이터로 변환. 키가 없으면 null 반환. */
export function resolveConfig(key: string): ResolvedConfig | null {
  const config = RESULT_CONFIGS[key];
  if (!config) return null;
  return {
    title: TITLES[config.title],
    description: DESCRIPTIONS[config.description],
  };
}

/**
 * 리드폼 제출 완료 화면의 추천 블로그.
 * 카테고리 배분(오피스 공간 2 · 사무실 구축 1 · 1인 전용 상품 1)과 정렬은 서버가 책임진다.
 */
export async function fetchLeadFormRecommendations(): Promise<BlogArticle[]> {
  try {
    const { data, error } = await fetchClient.GET('/api/v1/blogs/lead-form-recommendations', {});
    if (error || !data) return [];

    return data.map((blog) => toBlogArticle(blog)).filter((a): a is BlogArticle => a !== null);
  } catch {
    return [];
  }
}
